import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNextTen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M17.3416 21.12C15.2776 21.12 14.0656 19.38 14.0656 16.8C14.0656 14.208 15.2776 12.48 17.3416 12.48C19.4176 12.48 20.6296 14.208 20.6296 16.8C20.6296 19.38 19.4176 21.12 17.3416 21.12ZM17.3416 19.392C18.2536 19.392 18.8056 18.576 18.8056 16.8C18.8056 15.024 18.2536 14.208 17.3416 14.208C16.4416 14.208 15.8896 15.024 15.8896 16.8C15.8896 18.576 16.4416 19.392 17.3416 19.392Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M13.0504 12.6V21H11.2864V15.036L9.41442 16.476V14.352L11.8624 12.6H13.0504Z" }),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17.2929 3.29289C16.9024 3.68342 16.9024 4.31658 17.2929 4.70711L18.5858 6H8C4.68629 6 2 8.68629 2 12C2 15.1317 3.7211 17.2945 5.68377 17.9487C6.20772 18.1233 6.77404 17.8402 6.94868 17.3162C7.12333 16.7923 6.84017 16.226 6.31623 16.0513C5.2789 15.7055 4 14.3912 4 12C4 9.79086 5.79086 8 8 8H18.5858L17.2929 9.29289C16.9024 9.68342 16.9024 10.3166 17.2929 10.7071C17.6834 11.0976 18.3166 11.0976 18.7071 10.7071L21.7071 7.70711C22.0976 7.31658 22.0976 6.68342 21.7071 6.29289L18.7071 3.29289C18.3166 2.90237 17.6834 2.90237 17.2929 3.29289Z"
		})
	]
});
export default SvgNextTen;
